import React from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

const FlairRectBlue = () => {
  const { breakpoints } = useTheme();
  const isMobile = useMediaQuery(breakpoints.down('md'));
  const width = isMobile ? '240' : '300';
  const height = isMobile ? '320' : '400';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 300 400"
    >
      <defs><clipPath id="a"><rect width="300" height="400" fill="#b3cce0" /></clipPath></defs>
      <g clipPath="url(#a)">
        <path
          d="M126.777.587c18.457-5.819,140.259,33.975,157.781,46.671C297.164,53.013,300,64.132,
          299.691,76.821c4.064,59.618-34.539,247.944-74.657,297.9-6.252,10.673-13.629,15.28-29.428,
          14.294C154.8,387,.468,352.137,1.484,297.886-12.9,267,80.911-13.745,126.777.587"
          transform="translate(0 0.004)"
          fill="#b3cce0"
        />
      </g>
    </svg>
  );
};

export default FlairRectBlue;
